import { Box, Button, Typography } from '@mui/material';

import { FC, useEffect, useState } from 'react';

const CancellationForm: FC = () => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  // Load original PDF on mount
  useEffect(() => {
    const loadOriginalPdf = async () => {
      try {
        if (!pdfUrl) {
          const response = await fetch(
            '/assets/insurance_cancellation_form.pdf',
          );
          if (!response.ok) {
            throw new Error('Failed to fetch original PDF');
          }
          const blob = await response.blob();
          const url = URL.createObjectURL(blob);
          setPdfUrl(url);
        }
      } catch (error) {
        console.error('Error loading original PDF:', error);
      }
    };

    loadOriginalPdf();

    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [pdfUrl]);

  const handleDownload = async () => {
    try {
      if (pdfUrl) {
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = 'kuendigungsformular-haushaltsversicherung.pdf';
        link.click();
        URL.revokeObjectURL(pdfUrl);
      }
    } catch (error) {
      console.error('Failed to download PDF:', error);
    }
  };

  return (
    <Box>
      <Typography sx={{ mt: 2, fontWeight: 'bold' }} variant="h5">
        Kündigungsformular
      </Typography>
      <Typography sx={{ display: 'block', my: 2 }}>
        Füllen Sie das untenstehende Formular aus, um Ihre Kündigung zu starten.
        Alle notwendigen Felder sind bereits für Sie vorbereitet – Sie müssen
        nur noch Ihre Daten ergänzen und das Formular abspeichern.
      </Typography>
      {pdfUrl && (
        <Box sx={{ height: '90vh', my: 4 }}>
          <iframe
            src={pdfUrl}
            width="100%"
            height="100%"
            style={{ border: '1px solid #ccc' }}
            title="PDF Preview"
          />
        </Box>
      )}

      <Typography sx={{ display: 'block', my: 2 }}>
        Oder laden Sie das PDF direkt herunter und editieren Sie die Felder mit
        Ihrem PDF-Editor.
      </Typography>
      <Button
        sx={{ mb: 4 }}
        fullWidth
        variant="contained"
        color="primary"
        onClick={handleDownload}
      >
        Download PDF
      </Button>
    </Box>
  );
};

export default CancellationForm;
